module.exports = __webpack_public_path__ + "static/media/promotion.997dfdb5.svg";